import { useState } from 'react'
import { Bell, ShieldCheck, Palette, MailCheck, Moon, Sun } from 'lucide-react'
import { useTheme } from '../../ThemeContext'

export default function Setting() {
  const { theme, setTheme } = useTheme()
  const [state, setState] = useState({
    emailAlerts: true,
    pushAlerts: true,
    weeklyDigest: false,
    twoFactor: true,
    sessionTimeout: true,
    compactMode: false,
  })

  const toggle = (key) => {
    if (key === 'darkMode') {
      setTheme(theme === 'dark' ? 'light' : 'dark')
    } else {
      setState((prev) => ({ ...prev, [key]: !prev[key] }))
    }
  }

  const rows = [
    { key: 'emailAlerts', icon: <MailCheck size={14} />, label: 'Email Alerts', desc: 'Receive account and billing updates' },
    { key: 'pushAlerts', icon: <Bell size={14} />, label: 'Push Notifications', desc: 'Real-time system and activity alerts' },
    { key: 'weeklyDigest', icon: <Bell size={14} />, label: 'Weekly Digest', desc: 'Send weekly performance summary' },
    { key: 'twoFactor', icon: <ShieldCheck size={14} />, label: 'Two-factor Authentication', desc: 'Protect admin access with OTP' },
    { key: 'sessionTimeout', icon: <ShieldCheck size={14} />, label: 'Auto Session Timeout', desc: 'Automatically expire inactive sessions' },
    { key: 'compactMode', icon: <Palette size={14} />, label: 'Compact Data Density', desc: 'Show more rows and compact cards' },
    { key: 'darkMode', icon: theme === 'dark' ? <Moon size={14} /> : <Sun size={14} />, label: 'Dark Mode', desc: 'Switch between dark and light themes' },
  ]

  return (
    <div className="dash-page page-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 'var(--space-md)', alignItems: 'center', flexWrap: 'wrap' }}>
        <h1 className="page-title">Settings</h1>
        <button className="btn btn-primary">Save Changes</button>
      </div>

      <div className="card">
        <div className="card-header">
          <div>
            <div className="card-title">Workspace Preferences</div>
            <div className="card-subtitle">Configure security, notifications, and UI behavior</div>
          </div>
        </div>
        <div className="settings-list">
          {rows.map((item) => (
            <label key={item.key} className="settings-item">
              <div className="settings-meta">
                <span className="settings-icon">{item.icon}</span>
                <div>
                  <div className="settings-label">{item.label}</div>
                  <div className="settings-desc">{item.desc}</div>
                </div>
              </div>
              <button
                type="button"
                className={`toggle ${item.key === 'darkMode' ? (theme === 'dark' ? 'on' : '') : (state[item.key] ? 'on' : '')}`}
                onClick={() => toggle(item.key)}
                aria-label={`toggle ${item.label}`}
              >
                <span />
              </button>
            </label>
          ))}
        </div>
      </div>

      <style>{`
        .dash-page { display: flex; flex-direction: column; gap: var(--space-lg); width: 100%; }
        .settings-list { display: flex; flex-direction: column; gap: var(--space-sm); }
        .settings-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: var(--space-md);
          padding: .8rem .9rem;
          border: 1px solid var(--border);
          border-radius: var(--radius-sm);
          background: var(--bg-raised);
        }
        .settings-meta { display: flex; align-items: center; gap: var(--space-sm); }
        .settings-icon {
          width: 28px;
          height: 28px;
          border-radius: 8px;
          display: grid;
          place-items: center;
          color: var(--accent-hover);
          background: rgba(79, 70, 229, .12);
          border: 1px solid var(--border);
          flex-shrink: 0;
        }
        .settings-label { color: var(--text1); font-size: var(--fs-sm); font-weight: 600; }
        .settings-desc { color: var(--text3); font-size: var(--fs-xs); margin-top: 1px; }
        .toggle {
          width: 44px;
          height: 24px;
          border-radius: var(--radius-full);
          border: 1px solid var(--border);
          background: #ffffff; /* OFF state = white */
          position: relative;
          transition: all var(--ease-base);
          cursor: pointer;
          flex-shrink: 0;
        }

        /* knob */
        .toggle span {
          position: absolute;
          top: 2px;
          left: 2px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #4f46e5; /* OFF knob = blue */
          transition: transform var(--ease-base), background var(--ease-base);
        }

        /* ON state */
        .toggle.on {
          background: var(--accent); /* ON background */
          border-color: var(--accent);
        }

        .toggle.on span {
          transform: translateX(20px);
          background: #fff; /* ON knob = white */
        }
        
      `}</style>
    </div>
  )
}
